import {
  FlatList,
  View,
  ViewStyle,
  StyleSheet,
  TextStyle,
} from 'react-native';
import React from 'react';
import {spacing} from 'theme/Units';
import colors from 'theme/Colors';
import {Text} from 'ui-kits';

export type LegendType = {
  color: string;
  label: string;
  extras?: string;
};
type propTypes = Readonly<{
  data: LegendType[];
  fontSize?: number;
  tileWidth?: number;
  tileHeight?: number;
  minWidth?: number;
}>;
export function Legend(props: propTypes) {
  const {
    data,
    fontSize = 16,
    tileHeight = 16,
    tileWidth = 24,
    minWidth,
  } = props;
  const renderLegendItem = ({item}: {item: LegendType}) => {
    const colorStyle: ViewStyle = {backgroundColor: item.color};
    const fontStyle: TextStyle = {fontSize};
    const tileStyle: ViewStyle = {width: tileWidth, height: tileHeight};
    const legendStyle: ViewStyle = {minWidth};

    return (
      <View style={[styles.legend, legendStyle]}>
        <View style={[colorStyle, tileStyle]} />
        <Text style={[styles.label, fontStyle]}>{item.label}</Text>
        {item.extras && (
          <Text style={[styles.extras, fontStyle]}>{item.extras}</Text>
        )}
      </View>
    );
  };
  return (
    <View style={styles.container}>
      <FlatList
        data={data}
        renderItem={renderLegendItem}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    gap: spacing['16'],
    minWidth: 250,
  },
  legend: {
    paddingVertical: spacing['2'],
    flexDirection: 'row',
    gap: spacing['5'],
    alignItems: 'center',
  },
  label: {
    flex: 1,
    color: colors.palette.secondaryBlack5,
    fontWeight: '500',
  },
  extras: {
    color: colors.palette.secondaryBlack5,
    fontWeight: '500',
  },
});
